import * as React from "react";
import { FormattedDate } from "react-intl";
import { Column, TRUSTable } from "web_modules/shared/TRUSTable";

export const verticalHeaderTRUSTable = data => (
  <TRUSTable className="table hurdles-editor__table" data={data}>
    <Column dataKey="label" />
    <Column dataKey="value" />
  </TRUSTable>
);

export const formatDate = (d: string) =>
  d ? <FormattedDate value={d} timeZone="UTC" /> : <span />;
